import { useEffect, useState } from 'react';

const DISMISS_KEY = 'unsei.a2hs.dismissed';

function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  // @ts-expect-error iOS Safari 拡張
  const iosStandalone = window.navigator.standalone === true;
  const displayMode = window.matchMedia('(display-mode: standalone)').matches;
  return iosStandalone || displayMode;
}

function isIOS(): boolean {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}

export function A2HSHelp() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    if (window.localStorage.getItem(DISMISS_KEY)) return;
    setShow(true);
  }, []);

  if (!show) return null;
  const ios = isIOS();
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 px-3 pb-3 pointer-events-none">
      <div className="max-w-device w-full mx-auto pointer-events-auto rounded-2xl
                      bg-ink-900 text-ink-50 shadow-xl shadow-ink-900/30 p-4
                      dark:bg-ink-700">
        <div className="flex items-start gap-3">
          <span className="text-gold-400 text-xl leading-none" aria-hidden>⌂</span>
          <div className="flex-1 text-sm leading-relaxed">
            <p className="font-semibold">ホーム画面に追加すると毎朝1タップで開けます。</p>
            <p className="opacity-80 mt-1 text-xs">
              {ios
                ? '右上「…」メニュー → 「ホーム画面に追加」(iPhone Chrome)、または共有ボタン → 「ホーム画面に追加」(Safari)'
                : 'ブラウザのメニューから「ホーム画面に追加」を選択してください。'}
            </p>
          </div>
          <button
            aria-label="閉じる"
            onClick={() => {
              window.localStorage.setItem(DISMISS_KEY, '1');
              setShow(false);
            }}
            className="text-ink-300 hover:text-ink-50 text-lg leading-none px-2"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
